import { ThemeUICSSObject } from '@apia/theme';
import date from './date';
import rangeFilter from './rangeFilter';
/* IMPORT HERE */

const filters: ThemeUICSSObject = {
  date,
  rangeFilter,
  /* PREPEND HERE */
  '.requiredFilter__Border:not([disabled]).ApiaFilter__Range': {
    borderLeftStyle: 'solid !important',
    borderLeftWidth: '4px !important',
    borderLeftColor: 'palette.error.main',
  },
};

export default filters;
